export default __webpack_public_path__ + "9e7fcc6aae7ea9c7a806733af4e07638.png";